import { OperationTypeEnum } from "@gtpl/shared-models/common-models";

export class LotNumberRequest{
    plant:number;
    operation?:OperationTypeEnum;
    tabName?:OperationTypeEnum
    /**
     * @param plant
     * @param operation
     */
    constructor(plant:number,operation?:OperationTypeEnum,tabName?:OperationTypeEnum){
        this.plant = plant;
        this.operation = operation;
        this.tabName = tabName

    }
}